import { createServerFn } from "@tanstack/react-start";
import { loadBrandProfile } from "@/lib/brand-maintenance.server";

export const getBrandProfile = createServerFn({ method: "GET" })
  .inputValidator((data: { makeSlug: string }) => data)
  .handler(async ({ data }) => loadBrandProfile(data.makeSlug));
